<mat-form-field>
  <mat-label>Enter device ids</mat-label>
  <input matInput type="text" [(ngModel)]="value" (keyup.enter)="selectedCollars(value)" />
  @if (value) {
    <button matSuffix mat-icon-button aria-label="Clear" (click)="value = ''">
      <mat-icon>close</mat-icon>
    </button>
  } @else {
    <button
      matSuffix
      mat-icon-button
      [matMenuTriggerFor]="menu"
      aria-label="tooltip menu"
      class="suffix-info"
    >
      <mat-icon color="accent">info</mat-icon>
    </button>
  }
</mat-form-field>
@if (sortedSelectedDeviceIds().length > 1) {
  <div class="d-flex justify-content-between align-items-center list-container">
    <mat-checkbox [checked]="allDevicesSelectedCheckbox" (change)="selectAll($event)"
      >check all</mat-checkbox
    >

    <mat-icon (click)="clearSelection()" matTooltip="remove all">delete</mat-icon>
  </div>
}
<div class="overflow-wrapper">
  @for (item of sortedSelectedDeviceIds(); track $index) {
    <div class="list-container">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex justify-content-center align-items-center">
          <mat-checkbox
            [checked]="item.checked"
            (change)="onCheckboxChange(item.id, $event)"
          ></mat-checkbox>
          <div class="d-flex align-items-center">
            <div>{{ item.id }} &nbsp;</div>

            @if (isMapPage()) {
              <div>
                <vectronic-color-picker
                  [initialColor]="item.color"
                  (colorChanged)="colorChanged.emit({ $event, item })"
                ></vectronic-color-picker>
              </div>
            }
          </div>
        </div>

        <div>
          @if (
            item.checked && sortedSelectedDeviceIds().length && !isValidId(item.id) && isMapPage()
          ) {
            <mat-icon (click)="setMapFocus.emit(item.id)" class="mr-6" color="accent"
              >gps_fixed</mat-icon
            >
          }

          <mat-icon
            matTooltip="open device details"
            (click)="navigateToDeviceDetails(item.id)"
            color="accent"
            class="mr-6"
            >info</mat-icon
          >
          <mat-icon (click)="removeDeviceId(item.id)">close</mat-icon>
        </div>
      </div>
    </div>
  }
</div>

<mat-menu #menu="matMenu">
  <div class="menu-wrapper">
    <strong>search string examples</strong>
    @for (item of tooltipContent; track $index) {
      <p>
        <strong>{{ $index + 1 }}: </strong>{{ item.text }}
        <button mat-button (click)="tryTooltip(item.text)" class="suffix-info">try</button>
      </p>
    }
  </div>
</mat-menu>
